import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { UserProvider } from './Contexts/GlobalContext';
import { MessageProvider } from './Contexts/NotifContext';
import { TravelProvider } from './Contexts/TravelContext';
import { AuthProvider } from './Contexts/AuthContext';
import { CurrencyProvider } from './Contexts/CurrencyContext';
import NotificationMessage from './Components/Notification';
import { LoadingProvider } from './Contexts/LoadingContext';
import Loader from './Components/Loader';
import PWAPrompts from './Components/PWAPrompts';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Router>
    <LoadingProvider>
      <AuthProvider>
        <CurrencyProvider>
          <MessageProvider>
            <NotificationMessage>
              <TravelProvider>
                <UserProvider>
                  <Loader />
                  <PWAPrompts />
                  <App />
                </UserProvider>
              </TravelProvider>
            </NotificationMessage>
          </MessageProvider>
        </CurrencyProvider>
      </AuthProvider>
    </LoadingProvider>
  </Router>
);

// Opt into offline/precache support and installability. When a new build is
// waiting, surface a "reload to update" prompt instead of stranding users on
// the cached version (PWAPrompts listens for this event).
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('sw-update', { detail: registration }));
  },
});
